import { useParams } from "react-router-dom";
import PartidoTV from "../components/widgetsTV/partidoTV/partidoTV";

export default function PartidoTVPage() {
  const { match } = useParams();

  return (
    <PartidoTV match={match} />
  );
}